<template>
  <section class="home-posts">
    <aside>
      <header>
        <!-- <h3 class="title-with-icon m-t m-b"> <strong>DIKÉ</strong></h3> -->
        <img src="@/assets/img/svg/dike_logo.png" width="230" />
        <h4>Entenda seus direitos.</h4>
      </header>
      <p>
        Diké é o portal de informações da Crivelli Advogados Associados. Divulga
        diariamente conteúdos sobre os seus direitos, com análises, reflexões e
        informações de cunho jurídico. Vídeos, entrevistas, textos, podcasts e
        eventos. Confira!
      </p>
      <!-- <a class="button button-blue"> Confira! </a> -->
        <router-link
                  :to="{ name: 'blog' }"
                  class="button button-blue"
                  >Confira!</router-link
                >
    </aside>
    <div class="posts-wrapper">
      <h3><img src="@/assets/img/svg/articles.svg" width="15" /> ARTIGOS</h3>

      <scrollable-content container-class="post-list">
        <div
          class="post-list-item"
          v-for="item in posts.filter((prop) => prop.category != 1)"
          :key="`post-${item.id}`"
        >
          <post-card :post="item" :type="item.category" />
        </div>
      </scrollable-content>

      <h3 class="title-with-icon m-t m-b">
        <img src="@/assets/img/svg/video.svg" width="15" /> VÍDEOS
      </h3>

      <scrollable-content container-class="post-list">
        <div
          class="post-list-item"
          v-for="item in posts.filter((prop) => prop.category == 1)"
          :key="`post-${item.id}`"
        >
          <post-card :post="item" type="1" />
        </div>
      </scrollable-content>
    </div>
  </section>
</template>

<script>
import PostCard from "@/components/Blog/PostCard";
import ScrollableContent from "@/components/ScrollableContent";

export default {
  components: {
    PostCard,
    ScrollableContent,
  },
  props: ["posts"],

  methods: {},
};
</script>

<style>
</style>
